export const ASSIGNMENT_EXTRACTOR_KEYS = {
    ONLY_SEARCH_ASSIGNEE: "onlySearchAssigneeName",
    ONLY_SEARCH_FIRST_REVIEWER: "onlySearchFirstReviewerName",
    ONLY_SEARCH_SECOND_REVIEWER: "onlySearchSecondReviewerName",
    ONLY_SEARCH_ENTITY: "onlySearchEntityName",

    RESPONSIBLE: "responsible",
    FIRST_REVIEWER: "firstReviewer",
    SECOND_REVIEWER: "secondReviewer",
    ENTITY: "entity",
    TAGS: "tags",
    NOTIFY: "notify",

    EXPORT_ASSIGNEE: "assignee",
    EXPORT_ASSIGNEE_GROUP: "assigneeGroup",
    EXPORT_TAGS: "assigneeTags",
    EXPORT_FIRST_REVIEWER: "firstReviewer",
    EXPORT_SECOND_REVIEWER: "secondReviewer",
    EXPORT_ENTITY: "exportEntity",
} as const;

export const CTRL_EXTRACTOR_KEYS = {
    ACCESS_RIGHTS: "accessRight",
    ASSIGNMENT: "assignment",
    CONTROL_RESULT_COUNT: "controlResultCount",
    DUE_DATE_MANUAL: "dueDateManual",
    FINANCIAL_YEAR: "financialYear",
    LOGIN_PROTECTION: "loginProtection",
    NAME: "name",
    DESCRIPTION: "description",
    NOTIFICATION: "notification",
    PROGRAM: "program",
    SCHEDULING_TYPE: "schedulingType",
    SEGREGATION_OF_DUTIES: "segregationOfDuties",
    STATUS: "status",
    TAGS: "tags",
    NEXT_DUE_DATE: "nextDueDate",

    RECURRENCE_WEEKLY: "recurrenceWeekly",
    RECURRENCE_MONTHLY: "recurrenceMonthly",
    RECURRENCE_EVERY_TWO_MONTHS: "recurrenceEveryTwoMonths",
    RECURRENCE_QUARTERLY: "recurrenceQuarterly",
    RECURRENCE_HALF_YEARLY: "recurrenceHalfYearly",
    RECURRENCE_YEARLY: "recurrenceYearly",

    SCHEDULE_MONTHLY: "scheduleMonthly",
    SCHEDULE_EVERY_TWO_MONTHS: "scheduleEveryTwoMonths",
    SCHEDULE_QUARTERLY: "scheduleQuarterly",
    SCHEDULE_HALF_YEARLY: "scheduleHalfYearly",

    /**
     * This extractor is used only in the context of exporting controls to Excel.
     * It is always enabled and not available in web view.
     */
    EXPORT_CONTROL_ID: "id",
    /**
     * This extractor is used only in the context of exporting controls to Excel.
     * It is always enabled and not available in web view.
     */
    EXPORT_CONTROL_PROGRAM_ID: "programId",
} as const;
